import type { CommentDetailsNested } from "@/server/api/routers/comment";
import {
  extensionsStoryComment,
  type JSONContent,
  renderToHTMLString,
} from "@borderless/editor/server";

import type { Lang } from "@/langs";
import { cn } from "@borderless/ui/lib/utils";
import { type FC } from "react";
import { formatTimeAgo } from "../../_utils/format-time-ago";
import { CommentAuthorSection } from "./CommentAuthorSection";
import { CommentAction } from "./UserActions";
import { flattenComments } from "./flatten-comments";
export default function CommentTree({
  lang,
  postSlug,
  comments,
}: {
  lang: Lang;
  postSlug: string;
  comments: CommentDetailsNested[];
}) {
  return (
    <>
      {/* <PostMinimalAction
        postTitle={post.title}
        postSlug={post.slug}
        commentsCount={commentsCount}
        claps={post.claps}
        onCommentClick={() => {
          // scroll to id post-comment-editor
          const el = document.getElementById(commentEditorId);
          if (el) {
            el.scrollIntoView({ behavior: "smooth" });
          }
        }}
      /> */}
      <div>
        <ol>
          {comments.map((comment) => {
            return (
              <CommentListItem
                key={comment.id}
                comment={comment}
                postSlug={postSlug}
                depth={0}
                nestedComments={comment.children}
                lang={lang}
              />
            );
          })}
        </ol>
      </div>
    </>
  );
}

const CommentListItem: FC<{
  lang: Lang;
  comment: CommentDetailsNested;
  depth: number;
  postSlug: string;
  nestedComments: CommentDetailsNested[] | undefined;
}> = ({ comment, depth, postSlug, nestedComments, lang }) => {
  return (
    <li className={cn("flex w-full scroll-mt-16")} id={comment.id}>
      <div className={cn(depth === 0 && "hidden", depth >= 1 && "w-3")} />
      <div
        className={cn(
          "grow",
          depth === 0 && "p-5",
          depth >= 1 && "border-l-2 border-l-accent py-5 pl-6",
        )}
      >
        <div className="flex w-full justify-between">
          <CommentAuthorSection author={comment.author} />
          <p className="text-base leading-tight text-subtle">
            {formatTimeAgo(comment.createdAt)}
          </p>
        </div>
        <div className="h-5" />
        <div
          dangerouslySetInnerHTML={{
            __html: renderToHTMLString({
              content: comment.content as JSONContent,
              extensions: extensionsStoryComment({}),
            }),
          }}
        />
        <div className="h-3" />
        <CommentAction
          lang={lang}
          comment={comment}
          postSlug={postSlug}
          commentsCount={flattenComments(comment.children).length}
        />
        {
          // children follows
        }
        <div className="h-5" />
        <ol>
          {nestedComments?.map((comment) => {
            return (
              <CommentListItem
                key={comment.id}
                comment={{
                  ...comment,
                  children: [],
                }}
                postSlug={postSlug}
                depth={depth + 1}
                nestedComments={comment.children}
                lang={lang}
              />
            );
          })}
        </ol>
      </div>
    </li>
  );
};
